import React, { useContext } from 'react'
import dayjs from 'dayjs'

import redirectLogin from 'fetch/redirectLogin'
import { showToast } from '@turingshequ/react-toast/src'
import Avatar from 'components/Avatar'
import IfRender from 'components/IfRender'
import Go2Personal from 'components/Go2Personal'
import { YDLog } from 'components/YDLog'
import { iconCommit, iconDelete, iconThumbsub, iconThumbsubLight } from 'assets'
import { Item as ItemType } from 'fetch/works'
import { num2likestr, escapeHTML } from 'util/index'
import { UserContext } from 'components/UserProvider'

import { changeEmojiDesc2Img } from 'components/Emoji'

import { REPORT_TYPE } from '../../../ToReport'

import CommentContext from '../../store'

import s from './index.module.scss'

/** @ts-ignore */
interface Props {
  data: ItemType
  showReplay?: boolean
  onDelete?: () => void
  onLicked: (liked: boolean | undefined) => void
  onComment: () => void
}

function Item({ data, onDelete, onLicked, onComment, showReplay }: Props) {
  const currUserData = useContext(UserContext)
  const { isAuthor, onReport } = useContext(CommentContext)
  const currentUserId = currUserData.user?.userId
  const isSelf = data.userId === currentUserId
  const replayNum = data?.replyNum || 0
  const canDelete = isSelf || isAuthor

  const handleOnDelete = () => {
    if (currUserData === null) {
      redirectLogin()
      return
    }
    if (!canDelete) {
      return
    }
    onDelete && onDelete()
  }

  const handleLicked = (liked: boolean) => {
    if (currUserData.user === null) {
      redirectLogin()
      return
    }
    onLicked(liked)
  }


  const handleReport = () => {
    const text = data.type === 0 ? '回复' : '评论'
    if(data.hasReported) {
      showToast({
        type: 'default',
        message: `您已举报过该${text}，小图灵正在处理中，请耐心等待`
      })
      return
    }
    onReport({
      type: data.type === 0 ? REPORT_TYPE.reply : REPORT_TYPE.comment,
      id: data.id
    })
  }

  return (
    <div className={s.wrap}>
      <div style={{ flexShrink: 0 }}>
        <Go2Personal id={data.userId}>
          <Avatar size={44} url={data.image} />
        </Go2Personal>
      </div>
      <div className={s.textWrap}>
        <div className={s.itemTitle}>
          <Go2Personal id={data.userId}>{data.name}</Go2Personal>
          <IfRender show={data.isAuthor}>
            <span className={s.isAuthor}>作者</span>
          </IfRender>
          <IfRender show={data.type === 1}>
            <>
              <span className={s.replay}>回复</span>
              <Go2Personal id={data.replyUserId}>{data.replyName!}</Go2Personal>
            </>
          </IfRender>
        </div>
        <div
          className={s.itemDesc}
          dangerouslySetInnerHTML={{
            __html: changeEmojiDesc2Img(escapeHTML(data.content || '')),
          }}
        ></div>
        <div className={s.itemTime}>
          {dayjs(data.time).format('YYYY/MM/DD HH:mm:ss')}&nbsp;
          <span
            className={s.reportBtn}
            onClick={handleReport}
          >
            {'举报'}
          </span>
          <div className={s.itemHandle}>
            <span className={s.handleDel} onClick={handleOnDelete}>
              {canDelete && (
                <YDLog
                  click={{
                    name: 'click',
                    data: { button_name: '删除评论/回复' },
                  }}
                >
                  <img src={iconDelete} alt="" />
                </YDLog>
              )}
            </span>
            <YDLog
              click={{
                name: 'click',
                data: { button_name: '点赞', like_type: '点赞评论/回复' },
              }}
            >
              <span
                className={s.handleLiked}
                onClick={() => handleLicked(!!data.liked)}
              >
                <img
                  src={data.liked ? iconThumbsubLight : iconThumbsub}
                  alt=""
                />
                <i className={s.number}>{num2likestr(data.praiseNum)}</i>
              </span>
            </YDLog>
            <span className={s.handleComment} onClick={onComment}>
              <img src={iconCommit} alt="" />
              {showReplay && '收起回复 '}
              <i className={s.number}>
                {replayNum ? num2likestr(replayNum) : null}
              </i>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Item
